import classNames from 'classnames';

import styles from './NFCAnimation.module.scss';

export default function NFCAnimation() {
  return (
    <div className={styles.scene}>
      <div className={styles.iphone3d}>
        <div className={styles.front}>
          <div className={styles.screen}>
            <div className={styles.notch} />
          </div>
          <div className={styles.sideBtn} />
          <div className={styles.sideBtn2} />
        </div>
        <div className={styles.back}>
          <div className={styles.camera} />
          <div className={classNames(styles.camera, styles.cameraSecond)} />
        </div>
        <div className={styles.sideTop} />
        <div className={styles.sideRight} />
        <div className={styles.sideBottom} />
      </div>
      <div className={styles.nfcCard}>
        <img src={new URL('./DNI.svg', import.meta.url).href} alt="card" style={{ width: '100%', height: '100%' }} />
      </div>
    </div>
  );
}
